<template>
<div class="form-address">
  <gkFormCustomGroup
    class="address-wrap"
    :field="field"
    :rule="isValidity ? rules : []"
    :validity="isValidity"
     v-model="finalValue"
   >
  <template v-for="(option, i) in (data.details ? data.details.options : [])">
    <div class="input-wrap" :key="i">
      <gkFormText
        class="select"
        :field="'addressUseless'"
        :readonly="true"
        :placeholder="option.tips || defaultValue[option.type]"
        :value="addressValue[option.type] && addressValue[option.type].name"
        size="normal"
        color="gray"
        @focus="getSelectMessage($event, option.type)"
      />
    </div>
    </template>
    </gkFormCustomGroup>
    <div v-show="showAddressSelect">
      <ul ref="select-list" class="select-dropdown" :style="{left: inputLeft + 'px'}">
        <li
          v-for="item in selectMessage"
          :class="{isActive: activeId === item.id}"
          :key="item.id"
          @click="selectOption(focusType, item)"
        >
          {{item.name || '暂无数据'}}
        </li>
      </ul>
      <div class="cover" @click="showAddressSelect = false"></div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import ConfigService from '@/service/config.service'
import gkFormCustomGroup from 'gkui/form/FormCustomGroup'
import gkFormText from 'gkui/form/FormText'
import * as addressConstants from '../const'

export default {
  name: 'user-info-address',
  components: {
    gkFormCustomGroup,
    gkFormText
  },
  data () {
    return {
      areaOptions: [],
      finalValue: [],
      selectMessage: [],
      defaultValue: {
        [addressConstants.userInfoAddressProvince]: '-省/自治区/直辖市-',
        [addressConstants.userInfoAddressCity]: '-市-'
      },
      addressValue: [],
      showAddressSelect: false,
      inputLeft: 0,
      focusType: '',
      activeId: -1,
      addressConstants
    }
  },
  watch: {
    echoValue: {
      handler: function (newData, oldData) {
        try {
          const { userInfoAddressProvince, userInfoAddressCity } = this.addressConstants
          // eslint-disable-next-line camelcase
          const extraInfo = this.data?.extra_info && JSON.parse(this.data.extra_info)
          if (!extraInfo) {
            return
          }
          const { user_attribute: key } = extraInfo
          // key 为 address，对应userField中的 province 和 city 两个字段
          if (newData !== oldData && key === 'address' && newData?.areaOptions?.length && newData?.userFieldInfo?.province) {
            const { userFieldInfo, areaOptions } = newData
            const { province = [], city = [] } = userFieldInfo
            const provinceInfo = areaOptions.find(ele => ele.code === province[0])
            const cityInfo = provinceInfo.city.find(ele => ele.code === city[0])
            this.addressValue = {
              [userInfoAddressProvince]: provinceInfo,
              [userInfoAddressCity]: cityInfo
            }
            this.setFinalValue()
          }
        } catch (e) {
          console.log(e)
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    field () {
      return `${this.data.id}-${this.data.type}`
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    },
    options () {
      return this.data.details.options
    },
    rules () {
     let rule = []
     if (this.data.is_must_answer) {
       rule.push({
         required: '必填'
       })
     }
     return rule
    },
    // 用户信息组件的回显数据，watch 同时依赖两个数据
    echoValue () {
      return {
        userFieldInfo: this.userFieldInfo,
        areaOptions: this.areaOptions
      }
    }
  },
  props: {
    data: VueTypes.object.def({}),
    userFieldInfo: VueTypes.object.def({})
  },
  created () {
    ConfigService.getAreaList().then(data => {
      this.areaOptions = data
    })
  },
  methods: {
    getSelectMessage (event, type) {
      let path = event.path || (event.composedPath && event.composedPath())
      this.inputLeft = path[2].offsetLeft
      const { userInfoAddressProvince, userInfoAddressCity } = this.addressConstants

      this.focusType = type
      this.showAddressSelect = true

      if (type === userInfoAddressProvince) {
        this.selectMessage = this.areaOptions
      } else if (type === userInfoAddressCity && this.addressValue[userInfoAddressProvince]?.id) {
        this.city_options = this.areaOptions.find(ele => ele.id === this.addressValue[userInfoAddressProvince].id).city
        this.selectMessage = this.city_options.slice()
      }

      const activeId = this.addressValue[type]?.id
      if (activeId) {
        this.activeId = activeId
      }
    },
    setFinalValue () {
      const finalValue = Object.entries(this.addressValue).map(([type, item]) => {
        const option = this.options.find(ele => ele.type === +type)
        const obj = { key: option.key, value: item.code }
        return obj
      })
      if (this.data.is_must_answer && finalValue.length < 2) {
        this.finalValue = []
      } else {
        this.finalValue = finalValue
      }
    },
    // 设置input框的显示
    selectOption (type, item) {
      const { userInfoAddressProvince, userInfoAddressCity } = this.addressConstants
      if (item.id !== this.activeId) {
        if (type === userInfoAddressProvince) {
          delete this.addressValue[userInfoAddressCity]
        }
        this.addressValue[type] = item
        this.setFinalValue()
      }
      this.showAddressSelect = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/_common";
$default-color: #828A92;

.form-address {
  position: relative;

  .cover{
    position: fixed; z-index: 10; top: 0; left: 0; right: 0; bottom: 0;
    background-color: transparent;
  }
  & .address-wrap {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 80%;

    & .input-wrap {
      width: 175px;
      margin-bottom: 10px;
      margin-right: 9.5px;

      &:last-child{
        margin-right: 0;
      }

      & ::v-deep {
        & .gkui-form-element[data-color="gray"] {
          min-height: 40px;

          & .gkui-form-text {
            cursor: pointer;

              &::placeholder {
                color: rgba(130, 138, 146, 0.6);
                opacity: 1;
                zoom: 0.8;
            }
          }
        }

      }

      & .select {
        cursor: pointer;
        &::after {
          content: '';
          position: absolute;
          right: 20px; top: 50%;
          width: 9px; height: 7px;
          background: url('../../../../assets/img/form/sanjiao.png') no-repeat center/cover;
          transform: translateY(-50%);
        }

        & .gkui-form-text {
          cursor: pointer;
        }
      }
    }
  }

  & .select-dropdown {
    box-sizing: border-box;
    position: absolute; z-index: 100; top: 48px;
    padding: 10px 0;
    width: 175px; max-height: 200px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background: #ffffff;
    border: 1px solid $grayForm; border-radius: 4px;
    box-shadow: 6px 10px 16px rgba(0, 0, 0, 0.2);

    & li {
      height: 40px;
      padding: 0 10px;
      line-height: 40px;
      font-size: 16px;
      color: $bodyBlack;
      @extend %transition;

      &.isActive {
        position: relative;
        background: $blueHoverNew;
        color: #fff;
        &::after {
          content: '';
          position: absolute;
          right: 20px; top: 50%;
          width: 12px; height: 6px;
          border-left: 2px solid #fff;
          border-bottom: 2px solid #fff;
          transform: translateY(-50%) rotate(-45deg);
        }
      }

      &:hover {
        background: $blueHoverNew;
        color: #fff;
        @extend %transition;
      }
    }
  }
}
</style>
